export default __webpack_public_path__ + "static/media/kansas-th.482de2ef.png";